var map = {
	"./acontroller_selected.png": 7957,
	"./additional_controller_selected.png": 7324,
	"./battery_selected.png": 2023,
	"./bill_selected.png": 2797,
	"./box_selected.png": 6387,
	"./button_selected.png": 2108,
	"./cameraglass_selected.png": 5679,
	"./cd_selected.png": 7283,
	"./charger_selected.png": 1108,
	"./chargingport_selected.png": 1392,
	"./controller_selected.png": 3632,
	"./fingertouch_selected.png": 7934,
	"./frontcamera_selected.png": 834,
	"./hdmi_selected.png": 2070,
	"./keyboard_selected.png": 4465,
	"./lan_selected.png": 2005,
	"./microphone_selected.png": 3948,
	"./mouse_selected.png": 189,
	"./original_controllers_selected.png": 3525,
	"./powerbutton_selected.png": 1207,
	"./proximitysensor_selected.png": 2873,
	"./rearcamera_selected.png": 1713,
	"./remote_selected.png": 3482,
	"./simcard_selected.png": 3359,
	"./speaker_selected.png": 1959,
	"./speakerbutton_selected.png": 1779,
	"./touchpad_selected.png": 1828,
	"./trackpad_selected.png": 4828,
	"./usb_selected.png": 7820,
	"./vibrator_selected.png": 9782,
	"./volume_selected.png": 8006,
	"./webcamera_selected.png": 7827,
	"./wifibluetooth_selected.png": 2279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6907;